import { render, staticRenderFns } from "./UsersMembers.vue?vue&type=template&id=328a63b4&"
import script from "./UsersMembers.vue?vue&type=script&lang=js&"
export * from "./UsersMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports